import { Space } from "types/generated";

export const getDefaultValues = (space?: Space) => {
  return {
    spaceAccessLevel: space?.accessLevel,
    spaceId: space?.id,
  };
};
